export const getErrorMessage = (
  error: PromiseRejectionEvent["reason"] | Error,
): string => {
  let message: string = error.message || "";
  if (error.response?.data?.message) {
    message = error.response.data.message;
  }
  return message;
};
